import { StreamData } from 'types/streamData'
import WidgetType from 'enums/WidgetType'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const displayUrlResolver: FieldResolver = (metadata: Metadata) => {
  let displayUrl
  if (
    (metadata.getWidgetType() &&
      metadata.getWidgetType() === WidgetType.SOCIAL_WEB_POPULAR_LINKS) ||
    metadata.getWidgetType() === WidgetType.AUDIENCE_POPULAR_LINKS
  ) {
    displayUrl = metadata.getUrl() || metadata.getMentionedUrls()![0].displayUrl
  }

  return { displayUrl } as StreamData
}

export default displayUrlResolver
